import {createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as PhrasesActions from '../_actions/phrases.actions';
import {JournalEditMode} from '../_interface/journal-edit-mode.enum';
import {DocumentationPhraseDto} from 'app/_models/model/documentationPhraseDto';

export const phrasesFeatureKey = 'phrases';

export interface IPhrasesEntityState extends EntityState<DocumentationPhraseDto> {
	loaded: boolean;
	editPhrase: DocumentationPhraseDto | null;
	phraseIdToDelete: string | null;
	mode: JournalEditMode | null;
}

export const adapter: EntityAdapter<DocumentationPhraseDto> = createEntityAdapter<DocumentationPhraseDto>({
	selectId: (model) => model.phraseId
});

export const initialState: IPhrasesEntityState = adapter.getInitialState({
	loaded: false,
	editPhrase: null,
	phraseIdToDelete: null,
	mode: null
});


export const phrasesReducer = createReducer<IPhrasesEntityState>(
	initialState,
	on(PhrasesActions.addPhrases,
		(state, action) => adapter.addOne(action.phrases, state)
	),
	on(PhrasesActions.upsertPhrase,
		(state, {phrase}) => adapter.upsertOne(phrase, {...state, editPhrase: null, mode: null})
	),
	on(PhrasesActions.addPhrasess,
		(state, action) => adapter.addMany(action.phrasess, state)
	),
	on(PhrasesActions.upsertPhrasess,
		(state, action) => adapter.upsertMany(action.phrasess, state)
	),
	on(PhrasesActions.updatePhrases,
		(state, action) => adapter.updateOne(action.phrases, state)
	),
	on(PhrasesActions.updatePhrasess,
		(state, action) => adapter.updateMany(action.phrasess, state)
	),
	on(PhrasesActions.tryDeletePhrase, (state, {phraseId}) => ({
		...state,
		phraseIdToDelete: phraseId
	})),
	on(PhrasesActions.deletePhrase,
		(state, {phraseId}) => adapter.removeOne(phraseId, state)
	),
	on(PhrasesActions.deletePhrases,
		(state, action) => adapter.removeMany(action.ids, state)
	),
	on(PhrasesActions.loadPhrases,
		(state, action) => {
			return adapter.setAll(action.phrases, {...state, loaded: true});
		}
	),
	on(PhrasesActions.clearPhrases,
		state => adapter.removeAll(state)
	),
	on(PhrasesActions.editPhrase, (state: IPhrasesEntityState, {phraseId}) => ({
		...state,
		mode: JournalEditMode.edit,
		editPhrase: state.entities[phraseId]
	})),
	on(PhrasesActions.prepareEmptyPhrase, (state: IPhrasesEntityState, {phrase}) => ({
		...state,
		mode: JournalEditMode.create,
		editPhrase: phrase
	})),
	on(PhrasesActions.submitEditPhrase, (state: IPhrasesEntityState, {phrase}) => ({
		...state,
		editPhrase: {...state.editPhrase, ...phrase}
	})),
	on(PhrasesActions.cancelEditPhrase, (state: IPhrasesEntityState): IPhrasesEntityState  => ({
		...state,
		editPhrase: null,
		mode: null,
		phraseIdToDelete: null
	}))
);

export const {
	selectIds,
	selectEntities,
	selectAll,
	selectTotal,
} = adapter.getSelectors();
